export function focusElement(elementId: string) {
	document.getElementById(elementId)?.focus();
}
